import { use } from 'react';

import AcousticConfiguration from 'features/residents/models/configurations/acoustic-configuration';
import AcousticTimeFrameConfiguration from 'features/residents/models/configurations/acoustic-time-frame-configuration';
import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';

type Props = {
  acousticConfiguration: AcousticConfiguration;
  activeAllDay: boolean;
  index: number;
  valuesChanged: (newTimeFrameConfigurations: AcousticTimeFrameConfiguration[] | null, newActiveAllDay: boolean) => void;
  isTemporaryConfiguration: boolean;
  tempConfigSoundThresholdChanged?: (value: number) => void;
  tempConfigDurationChanged?: (value: number) => void;
};

export const useAcousticSettings = ({
  acousticConfiguration,
  activeAllDay,
  index,
  valuesChanged,
  isTemporaryConfiguration,
  tempConfigSoundThresholdChanged,
  tempConfigDurationChanged,
}: Props) => {
  const {
    detailEditState: { viewingMode },
  } = use(ResidentSettingsProviderContext);

  const soundThresholdChanged = (value: number): void => {
    if (isTemporaryConfiguration) {
      tempConfigSoundThresholdChanged?.(value);
      return;
    }

    const newTimeFrameConfigurations = [...(acousticConfiguration.acousticTimeFrameConfigurations ?? [])];

    newTimeFrameConfigurations[index].soundThreshold = value;

    valuesChanged(newTimeFrameConfigurations, activeAllDay);
  };

  const durationChanged = (value: number): void => {
    if (isTemporaryConfiguration) {
      tempConfigDurationChanged?.(value);
      return;
    }

    const newTimeFrameConfigurations = [...(acousticConfiguration.acousticTimeFrameConfigurations ?? [])];

    newTimeFrameConfigurations[index].duration = value;

    valuesChanged(newTimeFrameConfigurations, activeAllDay);
  };

  return {
    viewingMode,

    soundThresholdChanged,
    durationChanged,
  };
};
